let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4dUEB")).then(() => parcelRequire('kipwF'));